<template>
  <five-wide-column>
    <div
      class="ui sub header"
      style="margin-top: 1rem;">
      {{ $t('lessons.mobilePreview') }}
    </div>
    <!-- Preview -->
    <div
      class="ui fluid card"
      style="background-color: #222a34; min-width: 22.5rem;">
      <div
        class="content"
        style="color: white;">
        <div
          class="ui inverted header"
          style="color: white;">
          <a
            class="ui orange small horizontal label"
            style="margin-left:0; margin-bottom:0.5em;">{{ $t('lessons.newTag') }}</a>
          {{ item.data.title }}
          <div class="sub header">
            <i class="calendar icon"/> {{ $t('lessons.day') }} {{ item.data.options.startDay }}
          </div>
        </div>
      </div>
      <div class="image">
        <img
          class="ui image"
          src="https://dummyimage.com/1000x10/222a34/222a34.gif">
        <img
          class="ui image"
          v-if="imageLinkIsValid"
          :src="item.data.imageLink">
      </div>
      <div
        class="content"
        style="color: white;"
        v-html="item.data.body"/>
      <div class="extra content">
        <button
          class="ui small secondary button"
          v-if="item.data.options.secondaryText">
          <i :class="icon(item.data.options.secondaryIcon)"/>
          {{ item.data.options.secondaryText }}
        </button>
        <button
          class="ui right floated primary small button"
          v-if="item.data.options.primaryText">
          <i :class="icon(item.data.options.primaryIcon)"/>
          {{ item.data.options.primaryText }}
        </button>
      </div>
    </div>
  </five-wide-column>
</template>

<script>
import FiveWideColumn from '../utility/FiveWideColumn'
export default {
  name: 'LessonPreview',
  components: { FiveWideColumn },
  props: {
    item: {
      type: Object,
      required: true
    },
    imageLinkIsValid: {
      required: false,
      default: true,
      validator (value) {
        return typeof value === 'boolean' || value === null
      }
    }
  },
  computed: {
    icon () {
      return iconOption => {
        switch (iconOption) {
          case 'download':
            return 'download icon'
          case 'watch':
            return 'play circle icon'
          case 'email':
            return 'envelope icon'
          case 'read':
            return 'newspaper outline icon icon'
          default:
            return null
        }
      }
    }
  }
}
</script>

<style scoped>
.primary,
.secondary {
  background-color: #3e838a !important;
}
</style>
